import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../../api/auth';
import '../reset-password-page/style.css';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await requestPasswordReset(email);
        } catch {
            // Intentionally generic — don't reveal whether email exists
        }
        setMessage("If an account with that email exists, a reset link has been sent.");
        setSubmitted(true);
    };

    return (
        <div className="reset-password-page">
            <img src="/landmine_white.png" alt="Landmine Chess Logo" className="logo" />
            <div className="reset-container">
                <h2 className="reset-title">Forgot Password</h2>
                {!submitted ? (
                    <form className="reset-form" onSubmit={handleSubmit}>
                        <label className="reset-label">Email address:</label>
                        <input
                            type="email"
                            className="reset-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button className="reset-button" type="submit">Send Reset Link</button>
                    </form>
                ) : (
                    <p className="reset-message">{message}</p>
                )}
                <p className="reset-back" onClick={() => navigate('/sign-in')}>Back to sign in</p>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
